<template>
  <div class="duration-dropdown">
    <div class="duration-dropdown__label">Liczba dni</div>
    <div class="duration-dropdown__close">
      <span class="custom-icon--cross calendar-header__icon" @click="close" />
    </div>

    <RadioList class="duration-dropdown__body"
      :value="value.range" :options="value.ranges" @input="input" />

  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import Icon from '@/components/Icon.vue'
import RadioList from '@/components/RadioList.vue'

@Component({
  mixins: [
    AutoCloseMixin,
  ],
  components: {
    RadioList,
    Icon,
  },
  props: {
    value: {
      type: Object,
      required: false,
    },
  },
})
export default class Duration extends Vue {
  mounted () {
    this.$emit('adjustVisibility', this.$el)
  }

  input (value) {
    this.value.range = value
    this.$emit('close')
  }
}
</script>

<style lang="scss">
.duration-dropdown {
  background-color: #fff;
  position: absolute;
  width: 100%;
  padding: 10px;  
  box-shadow: 0 6px 12px rgba(0,0,0,.175);
  border: 1px solid rgba(0,0,0,.15);
  z-index: 1;
  margin-top: 4px;

  &__label {
    color: #005ca9;
    line-height: 1;
    font-size: 13px;
    font-weight: bold;
  }

  &__body {
    margin-top: 20px;
  }

  &__close {
    position: absolute;
    right: 0;
    padding: 0 7px;
    top: -3px;
    color: #005ca9;
    cursor: pointer;
    z-index: 1;
  }

  .radiolist-item__radiobutton {
    display: none;
  }

  .radiolist-item__label {
    padding-left: 0;

    &::before,
    &::after {
      display: none;
    }
  }

  .radiolist-item__label--selected {
    font-weight: bold;
    font-family: 'Gotham';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/DurationDropdown.vue